import { enterVideoFullscreen, exitVideoFullscreen } from "@/lib/videoFullscreen";

// Lot 762 — plein écran du direct « façon YouTube » : on agrandit la SCÈNE (vidéo + réactions + en-tête), jamais la
// salle entière (vidéo + commentaires) — sinon, avec le passage forcé en paysage, le téléphone gardait la mise en page
// empilée : vidéo sur 42 % de la hauteur et commentaires en dessous (« page à moitié »). Sur iPhone / iPad (pas de plein
// écran d'élément dans l'app), repli sur le plein écran vidéo AVKit. Retourne le chemin utilisé (tests).
export const isAnyFullscreen = () => !!(document.fullscreenElement || document.webkitFullscreenElement);

export const toggleLiveFullscreen = (stageEl, rootEl, { stageMode = true } = {}) => {
  if (isAnyFullscreen()) { exitVideoFullscreen(); return "exit"; }
  const target = stageMode ? (stageEl || rootEl) : (rootEl || stageEl);
  if (!target) return "none";
  const req = target.requestFullscreen || target.webkitRequestFullscreen;
  if (typeof req === "function") {
    try { const p = req.call(target); if (p && p.catch) p.catch(() => {}); return stageMode ? "stage" : "root"; } catch { /* unsupported → vidéo */ }
  }
  const video = typeof target.querySelector === "function" ? target.querySelector("video") : null;
  return video && enterVideoFullscreen(video) ? "video" : "none";
};
